











import { Vue, Component, Prop } from 'vue-property-decorator';

import CustomerImportService from '@/api/CustomerImportService';

import CustomerImportWelcomeTemplate from '@/componentsV2/templates/CustomerImportWelcome/CustomerImportWelcome.vue';

import {
  ECustomerImportProgressStatus,
  ICustomerImportStatus
} from '@/models/customer-import';
import { EEmptyStateTabs } from './CustomerImportEmptyState.vue';

@Component({
  components: {
    CustomerImportWelcomeTemplate
  }
})
export default class CustomerImportWelcome extends Vue {
  @Prop() customerImportData!: ICustomerImportStatus;

  customerImportService = new CustomerImportService();
  loading = false;

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  async handleGetStarted() {
    try {
      this.loading = true;

      const { clickedCTA } = this.$route.query;

      this.$analytics({
        eventCategory: `Import Customers Modals | Welcome`,
        eventAction: 'click',
        eventLabel: `Clicked on the "Get started" button${
          clickedCTA ? ' when user is from banner' : ''
        }`
      });

      await this.customerImportService.startImport(this.currentProvider.name);

      const { data } = await this.customerImportService.getImportStatus(
        this.currentProvider.name
      );

      const { status } = data;

      const eventMapper: Record<string, () => void> = {
        [ECustomerImportProgressStatus.DONE]: () => {
          this.$emit('empty-state-event', { type: 'goToCampaignCreation' });
        },
        [ECustomerImportProgressStatus.IMPORTING]: () => {
          this.$emit('empty-state-event', {
            type: 'goTo',
            data: { step: EEmptyStateTabs.PROGRESS }
          });
        },
        [ECustomerImportProgressStatus.QUEUED]: () => {
          this.$emit('empty-state-event', {
            type: 'goTo',
            data: { step: EEmptyStateTabs.PROGRESS }
          });
        },
        [ECustomerImportProgressStatus.PENDING]: () => {
          this.$emit('empty-state-event', {
            type: 'goTo',
            data: { step: EEmptyStateTabs.PROGRESS }
          });
        }
      };

      if (eventMapper[status]) eventMapper[status]();
    } finally {
      this.loading = false;
    }
  }
}
